import { Size } from '../types/size'

export const sizeToPx: Record<Size, string> = {
  m: '32px',
  l: '50px',
}
